var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"driver__container"},[_c('side-menu'),_c('router-view')],1),_c('footer-view',{staticStyle:{"border-top":"1px solid"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }